import { Component } from 'react';

class AgentPhoto extends Component {
  render() {
    let style = {
      marginRight: '10px',
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'middle',
      lineHeight: '1',
      fontSize: '16px',
    };
    let imgStyle = {
      height: this.props.height || '50px',
      width: this.props.width || '50px',
      borderRadius: '50%',
      border: '1px solid #afa8aa',
    };
    return (
      <div style={style}>
        <img style={imgStyle} src={this.props.image} />
      </div>
    );
  }
}

export default AgentPhoto;
